import React from 'react';
import { Box, Typography, useTheme, Fade } from "@mui/material";
import AllTermine from "../../components/termine/AllTermine";

const Termine = () => {
    const theme = useTheme();

    return (
        <Fade in timeout={800}>
            <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: 'auto', mb: 12 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mb: 6, flexWrap: 'wrap', gap: 2 }}>
                    <Box>
                        <Typography variant="h3" sx={{ fontWeight: 900, mb: 1, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
                            Termine
                        </Typography>
                        <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 600, opacity: 0.85, maxWidth: 720 }}>
                            Alle geplanten Trainings, Spiele und Events
                        </Typography>
                    </Box>
                </Box>
                <AllTermine />
            </Box>
        </Fade>
    );
}

export default Termine;
